import React from 'react'
import PropTypes from 'prop-types'

import BookADemo from './BookADemo'
import BookingSuccess from './BookingSuccess'
import BookingUnconfirmed from './BookingUnconfirmed'
import BookingDeclined from './BookingDeclined'
import BookingNext from './BookingNext'
import { models, regions, conditions } from './data'

const EnquiryForm = props => {
	const { formName, country, params } = props
	let modelOptions
	let regionOptions
	let conditionOptions
	if (country === 'NZ') {
		modelOptions = models.nz
		regionOptions = regions.nz
		conditionOptions = conditions.nz
	} else if (country === 'ZA') {
		modelOptions = models.za
		regionOptions = regions.za
		conditionOptions = conditions.za
	} else if (country === 'AU') {
		modelOptions = models.au
		regionOptions = regions.au
		conditionOptions = conditions.au
	}
	if (formName === 'book-a-demo') {
		return (
			<div className="EnquiryForm">
				<BookADemo
					formName={formName}
					regionOptions={regionOptions}
					modelOptions={modelOptions}
					conditionOptions={conditionOptions}
				/>
			</div>
		)
	} else if (formName === 'booking-success') {
		return (
			<div className="EnquiryForm">
				<BookingSuccess formName={formName} params={params} />
			</div>
		)
	} else if (formName === 'booking-unconfirmed') {
		return (
			<div className="EnquiryForm">
				<BookingUnconfirmed formName={formName} params={params} />
			</div>
		)
	} else if (formName === 'booking-declined') {
		return (
			<div className="EnquiryForm">
				<BookingDeclined formName={formName} params={params} />
			</div>
		)
	} else if (formName === 'booking-next') {
		return (
			<div className="EnquiryForm">
				<BookingNext formName={formName} params={params} />
			</div>
		)
	}
	return ''
}

EnquiryForm.propTypes = {
	formName: PropTypes.string,
	country: PropTypes.string,
	params: PropTypes.object,
}

export default EnquiryForm
